import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { TransportationServices } from './components/TransportationServices';
import { MaintenanceServices } from './components/MaintenanceServices';
import { CleaningServices } from './components/CleaningServices';
import { WhyChoose } from './components/WhyChoose';
import { CoverageMap } from './components/CoverageMap';
import { CtaBanner } from './components/CtaBanner';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  return <div className="min-h-screen bg-navy text-slate-300 font-sans selection:bg-gold/30 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBar data-id="element-4" />
        <TransportationServices data-id="element-5" />
        <MaintenanceServices data-id="element-6" />
        <CleaningServices data-id="element-7" />
        <WhyChoose data-id="element-8" />
        <CoverageMap data-id="element-9" />
        <CtaBanner data-id="element-10" />
        <Contact data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
      <FloatingWhatsApp data-id="element-13" />
    </div>;
}